var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 943.06 157.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.75,131.42v24.24H0V0H113.63V24.24H28.91v40.47H104.07v23.79H28.91v42.92H116.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.7,155.66l-30.46-41.14-30.69,41.14h-30.69l46.25-60.26-44.25-58.48h30.91l29.13,38.92,29.13-38.92h30.02l-44.47,58.04,46.48,60.71h-31.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M342.89,149.21c-6.67,5.34-16.68,8.01-26.68,8.01-26.02,0-40.92-13.79-40.92-40.03V60.04h-19.57v-22.24h19.57V10.67h27.8v27.13h31.8v22.24h-31.8v56.48c0,11.56,5.78,17.79,16.46,17.79,5.78,0,11.34-1.56,15.57-4.89l7.78,19.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M434.51,35.58v26.46c-2.45-.45-4.45-.67-6.45-.67-21.13,0-34.47,12.45-34.47,36.69v57.59h-27.8V36.91h26.46v17.35c8.01-12.45,22.46-18.68,42.25-18.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M556.81,86.06v69.6h-26.24v-14.45c-6.67,10.23-19.57,16.01-37.36,16.01-27.13,0-44.25-14.9-44.25-35.58s13.34-35.36,49.37-35.36h30.69v-1.78c0-16.23-9.78-25.8-29.58-25.8-13.34,0-27.13,4.45-36.02,11.79l-10.9-20.24c12.68-9.78,31.13-14.68,50.26-14.68,34.24,0,54.04,16.23,54.04,50.48Zm-27.8,32.47v-13.79h-28.69c-18.9,0-24.02,7.12-24.02,15.79,0,10.01,8.45,16.46,22.68,16.46s25.35-6.23,30.02-18.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M703.8,87.84v67.82h-15.79V89.39c0-24.68-12.9-37.36-35.13-37.36-25.13,0-40.92,15.57-40.92,42.25v61.38h-15.79V38.69h15.12v21.57c8.45-14.23,24.24-22.46,44.47-22.46,28.46,0,48.03,16.46,48.03,50.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M849,102.07h-97.84c1.78,24.46,20.46,40.69,46.03,40.69,14.23,0,26.91-5.11,35.8-15.34l8.89,10.23c-10.45,12.45-26.68,19.12-45.14,19.12-36.47,0-61.37-24.91-61.37-59.6s24.24-59.37,57.15-59.37,56.7,24.24,56.7,59.37c0,1.33-.22,3.11-.22,4.89Zm-97.84-11.79h82.94c-2-22.9-18.68-38.91-41.58-38.91s-39.36,16.01-41.36,38.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M943.06,148.54c-6.23,5.56-15.57,8.23-24.68,8.23-22.01,0-34.24-12.45-34.24-34.02V52.04h-20.9v-13.34h20.9V13.12h15.79v25.57h35.58v13.34h-35.58V121.86c0,13.79,7.12,21.35,20.24,21.35,6.45,0,12.9-2,17.35-6l5.56,11.34Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo__white.0812d4717783cedff7c43a77b18b8c8a.svg";
export { ForwardRef as ReactComponent };